<template>
    <div class="component" :class="[`type_${object.type} ${object.parentClass || ''}`, { 'maximize': maximize }]" @mouseleave="showMenu=false">
        <div class="menu" :title="$t('viewer.menu.open')" v-if="haveMenu" @click="showMenu=true" >
          <i v-if="!showMenu" class="btn fas fa-ellipsis-v"></i>
          <div class="wrapper">
            <transition name="slide">
              <div v-if="showMenu" class="items">
                <i @click.stop="showMenu=false" class="fas fa-times" :title="$t('viewer.menu.close')"></i>
                <i @click.stop="maximize=!maximize" :class="{ 'fas fa-expand-alt': !maximize, 'fas fa-compress-alt': maximize }" :title="$t(maximize ? 'viewer.menu.minimize' : 'viewer.menu.expand')"></i>
                <i v-for="(action, index) in menuActions" :key="index" :class="action.icon" @click.stop="executeAction(action.function)" :title="$t(action.title || '')"/>
              </div>
            </transition>
          </div>
        </div>
        <component v-bind:is="instance" :connection="connection" :plkparams="plkparams" :maximized="maximize"></component>
    </div>
</template>
<script>
import i18n from './i18n'
export default {
  name: 'ObjectLoader',
  props: {
    instance: {
      required: true
    },
    object: {
      required: true
    }
  },
  data () {
    return {
      showMenu: false,
      maximize: false
    }
  },
  computed: {
    haveMenu () {
      return (this.object || {}).menu === undefined || Array.isArray((this.object || {}).menu) ? true : this.object.menu
    },
    menuActions () {
      return (this.object || {}).menu && Array.isArray((this.object || {}).menu) ? this.object.menu : []
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    },
    executeAction (exec) {
      if (exec) {
        try {
          let fun = new Function(['ctx'], exec)
          return fun.apply(this, [this])
        } catch (e) {
          return exec
        }
      }
    }
  }
}
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.component.maximize {
  position: fixed;
  left: 0;
  top: 0;
  background: white;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  margin: 0px !important;
  z-index: 10;
}
.menu {
  position: absolute;
  display: none;
}
.component:hover .menu {
  display: block;
}
@media (hover: none) and (pointer: coarse) {
  .menu {
    display: block;
  }
}
.menu .btn {
  padding-top: .5rem;
  padding-left: 1rem;
  cursor: pointer;
}
.menu .wrapper {
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.menu .items {
  background-color: white;
  border: solid #efefef 1px;
  border-bottom: solid #efefef 1px;
  width: 25px;
  padding: 0 10px;
  border-radius: 0 0 20px 0px;
}
.menu .items i {
  margin: 13px 5px 14px;
  color: black;
  font-size: 1em;
  cursor: pointer;
}
.slide-enter-active, .slide-leave-active  {
  transition: all .6s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
